/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { useField } from 'formik';
import { Icon, Input } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import {
  LOWERCASE_REG_EX,
  NUMERIC_REG_EX,
  SPECIAL_CHARACTER_REG_EX,
  UPPERCASE_REG_EX,
} from '../../../utils/regex';

let CustomPasswordInput = ({
  labelText,
  getValue,
  requiredStar = false,
  t,
  ...props
}) => {
  const [isShownPass, setIsShownPass] = useState(false);
  const [field, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue } = helpers;

  const isLengthError = value.length === 0;
  const isUppercase = !UPPERCASE_REG_EX.test(value);
  const isLowercaseError = !LOWERCASE_REG_EX.test(value);
  const isNumericError = !NUMERIC_REG_EX.test(value);
  const isSpecialCharacterError = !SPECIAL_CHARACTER_REG_EX.test(value);

  return (
    <div className="formik-custom-field ">
      <label
        className={requiredStar ? 'required-stars' : ''}
        htmlFor={props.id || props.name}
      >
        {labelText}
      </label>
      <Input
        {...field}
        {...props}
        onChange={(e, data) => {
          setValue(data.value);
          getValue && getValue(data.value);
        }}
        value={value}
        error={meta.error}
        type={isShownPass ? 'text' : 'password'}
        icon={
          <Icon
            name={isShownPass ? 'eye' : 'eye slash'}
            onClick={() => {
              setIsShownPass(!isShownPass);
            }}
            link
          />
        }
      />
      {
        <div className="my-2">
          <div
            className={
              meta.error === 'LENGTH_ERROR' || isLengthError
                ? 'password-fail'
                : 'password-passed'
            }
          >
            <Icon name="check"></Icon>
            {t('formulary.password_validation.min_length')}
          </div>
          <div
            className={
              meta.error === 'UPPERCASE_ERROR' || isUppercase
                ? 'password-fail'
                : 'password-passed'
            }
          >
            <Icon name="check"></Icon>
            {t('formulary.password_validation.uppercase')}
          </div>{' '}
          <div
            className={
              meta.error === 'LOWERCASE_ERROR' || isLowercaseError
                ? 'password-fail'
                : 'password-passed'
            }
          >
            <Icon name="check"></Icon>
            {t('formulary.password_validation.lowercase')}
          </div>{' '}
          <div
            className={
              meta.error === 'NUMERIC_ERROR' || isNumericError
                ? 'password-fail'
                : 'password-passed'
            }
          >
            <Icon name="check"></Icon>
            {t('formulary.password_validation.numeric')}
          </div>{' '}
          <div
            className={
              meta.error === 'SPECIAL_CHARACTER_ERROR' ||
              isSpecialCharacterError
                ? 'password-fail'
                : 'password-passed'
            }
          >
            <Icon name="check"></Icon>
            {t('formulary.password_validation.special_character')}
          </div>
        </div>
      }
    </div>
  );
};

// Wrap component with withTranslation HOC
CustomPasswordInput = withTranslation()(CustomPasswordInput);
export { CustomPasswordInput };
